
import {
  Select as S,
  SelectProps,
} from "@chakra-ui/react";
import { DropdownIcon } from "./DropdownIcon";

export function Select(props: SelectProps) {
  return (
    <S icon={<DropdownIcon />} {...props}>
      {props.children}
    </S>
  );
}
